import React from 'react';
import * as css from './CommunicationsPanel.module.scss';
import 'src/css/themes.scss';
import { ConnectedVehicleRec } from 'src/models';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
    index: number;
    lastComm: number;
    row: number;
}

const CommunicationsPanel = (props: IProps) => {
    const warnMiles = props.connectedVehicle.comm[props.index].warnMile + ' ' +
        props.connectedVehicle.comm[props.index].warnMileUnit;

    return (
        <div className={props.row % 2 === 0 ? css.dataRow : css.dataRowOdd}>
            <div className={css.commDate}>{props.connectedVehicle.comm[props.index].warnDate}</div>
            <div className={css.commTime}>{props.connectedVehicle.comm[props.index].warnTime}</div>
            <div className={css.commType}>{props.connectedVehicle.comm[props.index].warnType}</div>
            <div className={css.commCode}>
                <div>{props.connectedVehicle.comm[props.index].featureCode}</div>
                <div>{props.connectedVehicle.comm[props.index].featureDesc}</div>
            </div>
            <div className={css.commDesc}>{props.connectedVehicle.comm[props.index].warnManual}</div>
            <div className={css.commUrgency}>
                <div>{props.connectedVehicle.comm[props.index].featureUrg}</div>
                <div>{props.connectedVehicle.comm[props.index].featureConf}</div>
            </div>
            <div className={css.commCondition}>{props.connectedVehicle.comm[props.index].warnFlag}</div>
            <div className={css.commOdometer}>{warnMiles}</div>
        </div>
    );
};

export default CommunicationsPanel;